export const EVENT_NAME = {
  UNSUB_CLICK: "CTA Clicked",
  UNSUB_SUCCESS: "Unsubscribe Success",
  UNSUB_FAIL: "Unsubscribe Fail",
  SUB_CLICK: "CTA Clicked",
  SUB_SUCCESS: "Subscribe Success",
  SUB_FAIL: "Subscribe Fail"
};
